<div class="container p-mb-6">
  <app-breadcrumb [listaPaginas]="[pathGams, pathCanal]"></app-breadcrumb>
  <app-menu-navegacao-superior-pagina [listaPaginas]="listaPaginas"></app-menu-navegacao-superior-pagina>

  <div class="sub-conteudo texto">
    <div class="p-grid nested-grid p-nogutter pagina-jfrn-sustentavel">
      <div class="p-col">
        <h2>Canal de acolhimento GAMS</h2>
        <hr />
        <div class="col-9">
          <p>Formulário para contato com a Comissão do GAMS.</p>

          <form [formGroup]="formulario" (ngSubmit)="onSubmit()">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-6">
                <label for="nome">Nome:</label>
                <input id="nome" class="w-100" pInputText type="text" formControlName="nome" />
                <div *ngIf="formulario.get('nome')?.invalid && formulario.get('nome')?.touched" class="text-danger">
                  O nome é obrigatório.
                </div>
              </div>

              <div class="p-field p-col-6">
                <label for="nomeSocial">Nome Social:</label>
                <input id="nomeSocial" class="w-100" pInputText type="text" formControlName="nomeSocial" />
              </div>

              <div class="p-field p-col-6">
                <label for="email">E-mail:</label>
                <input id="email" class="w-100" pInputText type="email" formControlName="email" />
                <div *ngIf="formulario.get('email')?.invalid && formulario.get('email')?.touched" class="text-danger">
                  E-mail inválido ou obrigatório.
                </div>
              </div>

              <div class="p-field p-col-6">
                <label for="telefone">Telefone celular:</label>
                <p-inputMask id="telefone" mask="(99) 99999-9999" placeholder="(__) _____-____" validateMask="true" formControlName="telefone"></p-inputMask>
                <div *ngIf="formulario.get('telefone')?.invalid && formulario.get('telefone')?.touched" class="text-danger">
                  O telefone é obrigatório.
                </div>
              </div>

              <div class="p-field p-col-6">
                <label for="tipoMensagem">Tipo:</label>
                 <p-select  placeholder="Selecione um tipo" [options]="tipoMensagem" autoWidth="true" [showClear]="true" formControlName="tipoMensagem"> </p-select>
              </div>

              <div class="p-field p-col-6">
                <label for="contatoRetorno">Contato Retorno:</label>
                 <p-select  placeholder="Selecione uma opção" [options]="tipoContato" autoWidth="true" [showClear]="true" formControlName="contatoRetorno"> </p-select>
              </div>

              <div class="p-field p-col-12">
                <label for="mensagem">Mensagem:</label>
                <textarea id="mensagem" class="w-100" pInputTextarea formControlName="mensagem" rows="5" placeholder="Digite sua mensagem aqui..."></textarea>
                <div *ngIf="formulario.get('mensagem')?.invalid && formulario.get('mensagem')?.touched" class="text-danger">
                  A mensagem é obrigatória.
                </div>
              </div>
            </div>

            <div *ngIf="successMessage" class="alert alert-success alert-dismissible fade show mt-4" role="alert">
              {{ successMessage }}
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="container botao">
              <button type="submit" class="btn btn-primary" [disabled]="loading">
                {{ loading ? 'Enviando...' : 'Submeter' }}
              </button>
            </div>
          </form>

          <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show mt-4" role="alert">
            {{ errorMessage }}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
